import { render, staticRenderFns } from "./GalleryMenu.vue?vue&type=template&id=68abb9b1&scoped=true"
import script from "./GalleryMenu.vue?vue&type=script&lang=js"
export * from "./GalleryMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68abb9b1",
  null
  
)

export default component.exports